
import InfoGeneralCard from "../components/InfoGeneralCard/InfoGeneralCard"
import { useEffect, useState } from "react";

const InfoGeneralContainer = ({}) => {

    const [infoGeneral, setInfoGeneral] = useState([]);
  
    useEffect(() => {
      fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/infoGeneral.json")
        .then((res) => res.json())
        .then((data) => setInfoGeneral(data))
        .catch((err) => console.error("Error cargando infoGeneral.json:", err));
    }, []);


  return (
    <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 columnas iguales
        gap: "20px", // espacio entre cartas
        width: "100%"}}>
        {infoGeneral.map((info) =>(
            <InfoGeneralCard
                key={info.name}
                imgSrc={info.img}
                spanTag="Información"
                name={info.name}
                footerText={info.footerText}
                description={info.description}
                infoExtra={info.infoExtra}
                link = {info.link}
                color="rgba(37, 149, 177, 1)"
            />
        ))
        }
    </div>
  )

}

export default InfoGeneralContainer